
import React from 'react';
import { useLocation } from 'react-router-dom';
import Navbar from '@/components/layout/Navbar';
import Footer from '@/components/layout/Footer';
import { Container } from '@/components/ui/container';
import { Button } from '@/components/ui/button';
import { Helmet } from 'react-helmet';
import { Mail } from 'lucide-react';
import { useNavigate } from 'react-router-dom';

const PasswordResetEmailSent = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const searchParams = new URLSearchParams(location.search);
  const email = searchParams.get('email') || '';
  
  const title = "Email-i i Rivendosjes së Fjalëkalimit u Dërgua";
  const description = `Një email për rivendosjen e fjalëkalimit u dërgua në adresën ${email}. Ju lutemi kontrolloni email-in tuaj dhe ndiqni udhëzimet për të rivendosur fjalëkalimin.`;
  const pageTitle = "Email-i i Rivendosjes u Dërgua | Tregu.al";
  const metaDescription = "Kontrollo email-in tuaj për instruksionet e rivendosjes së fjalëkalimit nga Tregu.al.";

  return (
    <div className="flex flex-col min-h-screen">
      <Helmet>
        <title>{pageTitle}</title>
        <meta name="description" content={metaDescription} />
      </Helmet>
      
      <Navbar />
      
      <main className="flex-grow py-16 bg-gray-50">
        <Container>
          <div className="max-w-md mx-auto mt-8 text-center">
            <div className="bg-white p-8 rounded-lg shadow-md">
              <div className="inline-flex items-center justify-center w-16 h-16 rounded-full bg-green-100 mb-6">
                <Mail className="w-8 h-8 text-green-600" />
              </div>
              
              <h1 className="text-2xl font-bold mb-4">{title}</h1>
              
              <p className="text-gray-600 mb-6">
                {description}
              </p>
              
              <Button
                onClick={() => navigate('/auth')}
                className="w-full"
              >
                Kthehu tek faqja e hyrjes
              </Button>
            </div>
          </div>
        </Container>
      </main>
      
      <Footer />
    </div>
  );
};

export default PasswordResetEmailSent;
